import { Pipe, PipeTransform, inject } from '@angular/core';
import { FilesService } from '@wilson/files';
import { User } from '@wilson/interfaces';
import { Observable, map, of } from 'rxjs';

@Pipe({
  name: 'getUserProfileImageUrl',
  standalone: true,
})
export class GetUserProfileImageUrlPipe implements PipeTransform {
  private readonly filesService = inject(FilesService);

  private readonly fallbackProfilePic = 'assets/img/profile/user-icon.svg';

  transform(user: User | null | undefined): Observable<string | undefined> {
    if (!user) {
      return of(undefined);
    }

    return user?.profileImageUrl
      ? this.filesService
          .getFileAccess(user.profileImageUrl)
          .pipe(map((fileAccess) => fileAccess?.accessUrl))
      : of(this.fallbackProfilePic);
  }
}
